const transformFileToVideoObject = file => ({
  path: file.data.relativePath,
  width: file.data.width,
  height: file.data.height,
});

export default transformFileToVideoObject;
